/* Description Tabs */
( function() {
    var headings = document.querySelectorAll( '.product__description_tabbed > h2' );
    if ( headings.length ) {

        var tabData = [];
        for ( var i = 0; i < headings.length; i++ ) {
            var tab = {};
            tab.heading = headings[i].textContent;
            tab.content = [];
            if ( headings[i].nextElementSibling ) {

                var content = headings[i].nextElementSibling;

                if ( i === headings.length - 1 ) {
                    tab.content.push( content.outerHTML );
                    while ( content.nextElementSibling ) {
                        content = content.nextElementSibling;
                        tab.content.push( content.outerHTML );
                    }
                } else if ( content !== headings[i+1] ) {
                    tab.content.push( content.outerHTML );
                    while ( content.nextElementSibling !== headings[i+1] ) {
                        content = content.nextElementSibling;
                        tab.content.push( content.outerHTML );
                    }
                }
            }

            tabData.push( tab );
        }

        if ( tabData.length ) {
            
            var wrapper = headings[0].parentNode;

            while ( headings[0].nextElementSibling ) wrapper.removeChild( headings[0].nextElementSibling );
            wrapper.removeChild( headings[0] );

            var tabs = document.createElement( 'nav' );
            tabs.classList.add( 'product__description_tabbed__tabs' );
            
            var contents = document.createElement( 'div' );
            contents.classList.add( 'product__description_tabbed__content' );

            for ( var i = 0; i < tabData.length; i++ ) {
                var tab = document.createElement( 'button' );
                tab.dataset.tabTarget = i;
                tab.textContent = tabData[i].heading;

                tab.addEventListener( 'click', function( event ) {
                    event.preventDefault();

                    for ( var j = 0; j < contents.children.length; j++ ) {
                        if ( contents.children[j].dataset.tabId !== this.dataset.tabTarget ) contents.children[j].classList.remove( 'active' );
                        else contents.children[j].classList.add( 'active' );
                    }

                    for ( var j = 0; j < tabs.children.length; j++ ) {
                        if ( tabs.children[j] !== this ) tabs.children[j].classList.remove( 'active' );
                        else tabs.children[j].classList.add( 'active' );
                    }

                } );

                var content = document.createElement( 'div' );
                content.dataset.tabId = i;
                content.innerHTML = tabData[i].content.join( '' );

                if ( 0 === i ) {
                    tab.classList.add( 'active' );
                    content.classList.add( 'active' );
                }

                tabs.appendChild( tab );
                contents.appendChild( content );

            }

            wrapper.appendChild( tabs );
            wrapper.appendChild( contents );

        }

    }
} )();